module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('max-z-index', {
    attrs: {
      "show": _vm.currentValue,
      "relative": _vm.relative
    }
  }, [_c('div', {
    staticStyle: {
      "touch-action": "none"
    },
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('masks', {
    attrs: {
      "mshow": _vm.currentValue,
      "mopacity": _vm.mOpacity
    },
    on: {
      "onHide": _vm.maskHide
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.dialogStyle,
    staticStyle: {
      "z-index": "2002"
    },
    style: ({
      whight: _vm.whight,
      top: '0px'
    })
  }, [_vm._t("default")], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f3b29e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/dialog/login-dialog.vue
// module id = 97
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 14 15 16 17 18 20 21 22 24 25 26 29 31 32 33 34 35 37 38 41 42 43 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63